import { post } from 'modules/api';

export const createGiftCardPaymentAnonymous = params =>
    post('boutique/gift_cards/buy/anonymous', params);
